<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Send Maccsbox results') }}</h4>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label>
          <input type="checkbox" v-model="selectAllMovies" true-value="1" false-value="0" /> {{ _('Send all movies') }}
        </label>
      </div>
      <div class="form-group" v-if="parseInt(selectAllMovies) !== 1">
        <label for="movie">{{ _('Movie') }}</label>
        <v-select :options="filteredMovies" v-model="selectedMovie" label="title" keys="['title']" :placeholder="_('Type to search movies')" :create-item="false">
          <template v-slot:no-options="{ searching }">
            <template v-if="searching">
              {{ _('No results found.') }}
            </template>
            <template v-else>{{ _('Type to search movies') }}</template>
          </template>
          <template v-slot:option="option">
            <span>{{ option.title }}</span>
          </template>
        </v-select>
      </div>
      <label for="data-range">{{ _('Date range') }}</label>
      <div class="rangeFields">
        <div class="form-inline">
          <div class="form-group">
            <DatePicker v-model="dateStart" :max-date="dateEnd" :shortLocale="shortLocale" :staticInput="true"></DatePicker>
          </div>
          <label for="endDate"> - </label>
          <div class="form-group">
            <DatePicker v-model="dateEnd" :min-date="dateStart" :shortLocale="shortLocale" :staticInput="true"></DatePicker>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="sendResults" :disabled="canSend"><i class="fa fa-fw fa-send"></i> {{ _('Send results') }}</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      selectedMovie: null,
      selectAllMovies: 0,
      dateStart: false,
      dateEnd: false,
      filteredMovies: []
    }
  },
  props: ['movies'],
  computed: {
    ...mapGetters(['locale', 'dateFormat']),
    shortLocale () {
      return this.locale.split('_')[0]
    },
    selectableMovies () {
      const moviesList = this.movies.map(m => ({ id: m.id, title: m.name }))
      return moviesList.sort((a, b) => {
        if (a.title < b.title) {
          return -1
        }
        if (a.title > b.title) {
          return 1
        }
        return 0
      })
    },
    canSend () {
      if (this.dateStart && this.dateEnd && this.dateStart <= this.dateEnd && ((this.selectedMovie && this.selectedMovie.id) || parseInt(this.selectAllMovies) === 1)) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    sendResults () {
      let start = new Date(this.dateStart)
      let end = new Date(this.dateEnd)
      let startYear = start.getFullYear()
      let startMonth = (start.getMonth() + 1) < 10 ? '0' + (start.getMonth() + 1) : start.getMonth() + 1
      let startDate = start.getDate() < 10 ? '0' + start.getDate() : start.getDate()
      let endYear = end.getFullYear()
      let endMonth = (end.getMonth() + 1) < 10 ? '0' + (end.getMonth() + 1) : end.getMonth() + 1
      let endDate = end.getDate() < 10 ? '0' + end.getDate() : end.getDate()

      let data = {
        selectedMovie: this.selectedMovie,
        selectAllMovies: this.selectAllMovies,
        dateStart: startYear + '-' + startMonth + '-' + startDate,
        dateEnd: endYear + '-' + endMonth + '-' + endDate
      }
      this.$emit('sendRequest', data)
    },
    searchMovies (text) {
      if (!text) {
        this.filteredMovies = this.selectableMovies
        return
      }
      this.filteredMovies = this.selectableMovies.filter(m => m.title && m.title.toLowerCase().includes(text.toLowerCase()))
    }
  },
  mounted () {
    this.filteredMovies = this.selectableMovies
  }
}
</script>

<style scoped>
code {
  display: block;
  line-break: anywhere;
}
</style>